import { AuthenticationMethod, CreateAuthMethodProps } from 'auth/types/authentication-method.type';
import { createAfAuthMethod } from './af/af-auth-method';
import { createClientAuthMethod } from './client/client-auth-method';

export const createAuthMethod = (props: CreateAuthMethodProps): AuthenticationMethod => {
  if (props.method === 'afSso') return createAfAuthMethod(props);
  if (props.method === 'client') return createClientAuthMethod(props);
  throw new Error('Authentication method is not supported.');
};
